import * as _ from "lodash";
import * as $ from "jquery";
import {BaseView} from "../_BaseViews";
import {DashboardTabCollection} from "../../collections/DashboardTabs";
import {DashboardTab} from "../../models/DashboardTab";
import {DashboardTabView, DashboardTabViewOptions} from "./DashboardTabView";
import {PermissionCollection} from "../../collections/Permissions";

declare var App;

export interface DashboardTabsViewOptions extends Backbone.ViewOptions<Backbone.Model> {
    dashboardTabCollection: DashboardTabCollection;
    activeTabId: number;
    permissionCollection: PermissionCollection;
    dashboardId: number;
    onTabSwitch: (tabId: number) => void;
    onTabAdd: () => void;
    onTabEdit: (tab: DashboardTab) => void;
    onTabClone: (tab: DashboardTab) => void;
    onTabMove: (tab: DashboardTab) => void;
    onTabDelete: (tab: DashboardTab) => void;
    onTabReorder?: (sourceTabId: number, targetTabId: number) => void;
}

export class DashboardTabsView extends BaseView {
    options: DashboardTabsViewOptions;
    private tabViews: DashboardTabView[] = [];

    constructor(options: DashboardTabsViewOptions) {
        super(_.extend({
            tagName: "div",
            className: "dashboard-tabs"
        }, options));
        
        this.listenTo(this.options.dashboardTabCollection, 'add remove reset sort', this.render);
    }

    render() {
        this.$el.empty();
        this.tabViews = [];
        
        const tabs = this.options.dashboardTabCollection.models;
        
        const self = this;
        const totalTabCount = tabs.length;
        tabs.forEach((tab: DashboardTab) => {
            const tabView = new DashboardTabView({
                tab: tab,
                activeTabId: this.options.activeTabId,
                totalTabCount: totalTabCount,
                permissionCollection: this.options.permissionCollection,
                dashboardId: this.options.dashboardId,
                onTabClick: this.options.onTabSwitch,
                onTabEdit: this.options.onTabEdit,
                onTabClone: this.options.onTabClone,
                onTabMove: this.options.onTabMove,
                onTabDelete: this.options.onTabDelete
            });
            
            // Listen for reorder events from tab views
            tabView.$el.on('tab:reorder', (e: JQuery.Event, data: { sourceTabId: number, targetTabId: number }) => {
                if (self.options.onTabReorder) {
                    self.options.onTabReorder(data.sourceTabId, data.targetTabId);
                }
            });
            
            this.tabViews.push(tabView);
            this.$el.append(tabView.render().$el);
        });
        
        // Add "Add Tab" button only when user has modify permissions
        if (this.options.permissionCollection.canModifyDashboard(this.options.dashboardId)) {
            const $addButton = $('<div class="dashboard-tab-add tw-opacity-80 hover:tw-opacity-100 tw-transition-opacity tw-cursor-pointer tw-p-4 tw-rounded-full tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-200" style="margin-top: -6px;"><i class="fa-regular fa-plus tw-text-gray-700"></i></div>');
            $addButton.on('click', () => {
                this.options.onTabAdd();
            });
            this.$el.append($addButton);
        }

        return this;
    }
    
    showSkeleton() {
        // Show the skeleton from the template
        const $container = this.$el.closest('.dashboard-tabs-container');
        if ($container.length > 0) {
            const $skeleton = $container.find('.dashboard-tabs-skeleton');
            $skeleton.removeClass('tw-hidden');
            $skeleton.css('display', 'flex');
        }
    }
    
    hideSkeleton() {
        // Hide the skeleton from the template
        const $container = this.$el.closest('.dashboard-tabs-container');
        if ($container.length > 0) {
            const $skeleton = $container.find('.dashboard-tabs-skeleton');
            $skeleton.addClass('tw-hidden');
            $skeleton.css('display', 'none');
        }
    }

    setActiveTab(tabId: number) {
        this.options.activeTabId = tabId;
        // Update active class on existing elements only; avoid full render to preserve scroll position
        this.$el.find('.dashboard-tab.active').removeClass('active');
        if (tabId != null) {
            this.$el.find('.dashboard-tab[data-tab-id="' + tabId + '"]').addClass('active');
        }
    }
}




// WEBPACK FOOTER //
// ./srv/public/js/views/dashboard/DashboardTabsView.ts